
export default {
  name: 'MentorInfo',

  data() {
    return {
      i18n: 'pages.education.courses-list.modal.mentor-new',
      startPathBlock: ['explain', 'how-to'],
      whatYouGetBlock: ['grow', 'status', 'karma', 'connection']
    }
  }
}
